import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteUserAccount } from '@arrived/api_v2';
import { Account, AccountId } from '@arrived/models';

import { UseMutationOptions } from '../queries.utils';
import { accountsPrimaryKeyFn, currentUserKeyFn, userKeyFn } from '../users';
import { accountsKeyFn } from './accounts.keys';

export function useDeleteAccountMutation(options?: UseMutationOptions<Account, AccountId>) {
  const queryClient = useQueryClient();

  return useMutation((accountId) => deleteUserAccount(accountId), {
    ...options,
    onSuccess: (data, variables, context) => {
      const primaryAccount = queryClient.getQueryData<Account | undefined>(accountsPrimaryKeyFn());

      if (primaryAccount?.id === data.id) {
        queryClient.removeQueries(accountsPrimaryKeyFn());

        queryClient.setQueryData(currentUserKeyFn(), data.primaryUser);

        queryClient.invalidateQueries(currentUserKeyFn());
      }

      queryClient.removeQueries(accountsKeyFn(data.id));

      queryClient.setQueryData(userKeyFn(data.primaryUser.id), data.primaryUser);

      queryClient.invalidateQueries(userKeyFn(data.primaryUser.id));

      options?.onSuccess?.(data, variables, context);
    },
  });
}
